import { useBroadcastChannel } from '@vueuse/core';
import type { UserProfile } from '~~/models/Session';

/**
 * TODO: We should realy rename this to somthing like 'refreshExpUserStates'
 * and the current user and shopping cart ids
 */
export const getExpUserProfile = async () => {
    const logger = useLogger('getExpUserProfile');

    try {
        const userProfile = await $fetch<UserProfile>('/api/expUserProfile', {
            headers: useRequestHeaders(['cookie']),
            retry: 3,
            retryStatusCodes: [404, 408, 409, 425, 429, 500, 502, 503, 504],

        });

        if (userProfile?.storeId !== useStoreCookie()?.value) {
            logger.warn('[bt-expUser] user profile storeID and store ID do not match!');
        }
        useCurrentUserState().value = userProfile;
        const defaultAddress = userProfile?.addresses?.find(
            (address: any) => address.id == userProfile?.defaultAddress,
        );
        useCurrentSessionIdentifier().value = userProfile?.sessionIdentifier;
        if (userProfile?.roles && userProfile.roles.length > 1) {
            setABContextVariable('targetingKey', useExpCookieIdentifier()?.value ?? 'bt_undefined');
            setABContextVariable('user_id', userProfile?.userId);
            setABContextVariable('roles', userProfile?.roles);
            setABContextVariable('email_domain', defaultAddress?.email?.split('@')?.at(1));
        }

        const { isSupported: userChannelSupported, post: postUserChange } = useBroadcastChannel({
            name: 'user-context-channel',
        });
        if (userChannelSupported?.value) {
            postUserChange(useCurrentUserState().value.userId);
        }

        return userProfile;
    } catch (error) {
        logger.log('error trying to fetch session info' + error);
    }
};

/**
 * Handles refreshing the CSRF Token from the CMS Services
 * @date 11.7.2023 - 09:55:44
 *
 * @export
 * @async
 * @param {?string} [sessionId]
 * @returns {UserProfile}
 */
export async function refreshCSRFToken(sessionId?: string) {
    if (import.meta.server && sessionId === undefined) {
        console.log('[bt-expUser] returning empty user for ssr');
        return;
    }
    let session = sessionId;
    if (sessionId === undefined) {
        session = '' + useCookie('session', { secure: true, httpOnly: true, sameSite: 'none' }).value;
        if (sessionId !== session) {
            console.warn('[bt-expUser] found different session to check than in cookie');
            if (sessionId) {
                session = sessionId;
            }
        }
    }
    const userProfile = useCurrentUserState().value;

    if (userProfile != undefined && userProfile != null) {
        if (userProfile?.storeId != useCurrentStore()?.value?.id) {
            if (userProfile?.csrfToken == undefined) {
                const { data } = await useFetch('/_api/user/getCsrfToken', {
                    query: {
                        branch_id: useCurrentStore()?.value?.id,
                    },
                    headers: {
                        'bt-vue-client': 'nuxt',
                        'bt-use-user-auth': 'true',
                        cookie: session,
                    },
                });
                userProfile.csrfToken = data?.csrfToken;
            }
            console.warn(
                `[bt-expUser] stores do not match!! profileState=${userProfile?.storeId} and currentStore=${useCurrentStore()?.value?.id}`,
            );
            const { error, data } = await useFetch('/_api/storeFinder/assignStore', {
                method: 'POST',
                headers: {
                    'bt-vue-client': 'nuxt',
                    'bt-use-user-auth': 'true',
                    'csrf-token': userProfile?.csrfToken,
                    cookie: session,
                },
                body: JSON.stringify({
                    storeId: useCurrentStore()?.value?.id,
                }),
            });
            console.info(`[bt-expUser] got assignStore result: ${data.value?.id}`);
            useStoreCookie().value = userProfile?.storeId;

            if (error?.value) {
                console.error('[bt-expUser] Could not fetch fresh csrf token ' + error.value);
            } else if (data?.value) {
                userProfile.csrfToken = data?.value?.csrfToken;
            }
        }
    }
    return userProfile;
}
